import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import styles from "../../../layout/admin/Main.module.scss";
import SearchForm from "./StudentSearchForm";
import {
  GetStudentList,
  GetUnapplovalCount,
} from "../../../../services/apiStudent";
import DataTable from "../../../features/DataTable";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import Button from "../../../ui/Button";
import CSVDownloader from "../../../ui/CSVDownloader";
import Explanation from "../../../layout/admin/Explanation";
import StudentUploadModal from "./StudentUploadModal";
import { calcEndOfYearAge } from "../../../../utils/calcAge";

const approvalValueApproved = 1; //承認

const tableMeata = [
  { key: "login_id", label: "学生番号(8桁)" },
  { key: "name", label: "氏名" },
  { key: "name_kana", label: "フリガナ" },
  { key: "street_name1", label: "町名" },
  { key: "street_name2", label: "丁名" },
  { key: "birthday", label: "生年月日" },
];

const StudentUser = () => {
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({
    approval_status_1: true,
  });
  // 検索結果データ
  const [tableData, setTableData] = useState([]);
  const [tableSortData, setTableSortData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [unapplovalCount, setUnapplovalCount] = useState([]);
  const tableResetRef = useRef();
  // csvアップロードモーダル表示ステータス
  const [showUploadModalFlag, setShowUploadModalFlag] = useState(false);
  // 再レンダリングステータス
  const [reloadFlag, setReloadFlag] = useState(true);

  // csvアップロードモーダル表示
  const showUploadModal = () => {
    setShowUploadModalFlag(true);
  };

  //検索条件更新時の動作
  useEffect(() => {
    (async function () {
      const data = await GetUnapplovalCount();
      if (!data) return;
      setUnapplovalCount(data.unapploval);
    })();
  }, []); //初回レンダリング

  //検索条件更新時の動作
  useEffect(() => {
    const mapTableDataFunc = (d) => {
      let login_id_component;
      if (d.approval_status === approvalValueApproved) {
        //承認済み生徒の場合、学生番号を表示
        login_id_component = (
          <Link to={"/admin/student/detail/" + d.user_id}>{d.login_id}</Link>
        );
      } else {
        //認証されていない場合、承認ステータスを表示
        login_id_component = (
          <Link to={"/admin/student/approval/" + d.user_id}>
            {d.approval_status_text}
          </Link>
        );
      }
      return {
        key: d.user_id,
        login_id: login_id_component,
        name: d.is_wheelchair ? "【車いす】" + d.name : d.name,
        name_kana: d.name_kana,
        street_name1: d.street_name1,
        street_name2: d.street_name2,
        birthday: d.birthday_text,
      };
    };
    const mapTableSortDataFunc = (d) => {
      return {
        key: d.user_id,
        login_id: d.login_id,
        name: d.name,
        name_kana: d.name_kana,
        street_name1: d.street_name1,
        street_name2: d.street_name2,
        birthday: d.birthday_text,
      };
    };
    const mapCsvDataFunc = (d) => {
      return {
        ユーザーID: d.user_id,
        "学生番号(8桁)":
          d.approval_status === approvalValueApproved ? d.login_id : "",
        "期生ID(入学年月)": d.generation_id,
        氏名: d.name,
        フリガナ: d.name_kana,
        郵便番号: d.postcode,
        都道府県: d.pref,
        町名: d.street_name1,
        丁名: d.street_name2,
        "番地・号": d.address,
        方書き: d.street_name3,
        生年月日: d.birthday_text,
        "年齢(年度末時点)": d.birthday ? calcEndOfYearAge(d.birthday) : "",
        性別: d.gender,
        電話番号1: d.phone_1,
        メールアドレス1: d.mail_1,
        電話番号2: d.phone_2,
        メールアドレス2: d.mail_2,
        "緊急連絡先(氏名)": d.emergency_name,
        "緊急連絡先(続柄)": d.emergency_emereletion,
        "緊急連絡先(電話番号)": d.emergency_phone,
        提出日: d.filing_date,
        メール配信: d.is_email === true ? "配信する" : "配信しない",
        ログイン拒否: d.is_rejection === true ? "ログイン不可" : "ログイン可",
        学生区分: d.student_type_text,
        "卒業生・在校生": d.is_graduation === true ? "卒業生" : "在校生",
        承認状況: d.approval_status_text,
        学生番号発行年月日: d.date_issue_num,
        備考: d.remarks,
        入学説明会出欠: d.is_attendance,
        車いす: d.is_wheelchair === true ? "該当" : "非該当",
      };
    };

    (async function () {
      // 再レンダリングフラグがFalseの場合はなにもせずにreturn
      if (!reloadFlag) return;
      const data = await GetStudentList(searchCondition);
      if (!data) return;
      //検索結果データセット
      setTableData(data.map(mapTableDataFunc)); //テーブル
      setTableSortData(data.map(mapTableSortDataFunc)); //テーブル
      setCsvData(data.map(mapCsvDataFunc)); //CSV
      //ページネーション・ソートをリセット
      tableResetRef.current?.click();
    })();
  }, [searchCondition, reloadFlag]);

  return (
    <div className={styles.main}>
      <ScreenTitle>学生管理</ScreenTitle>
      <SubScreenTitle>学生新規登録</SubScreenTitle>
      <div className={styles.buttonbox__left}>
        <Link to={"/admin/student/detail/new/0"}>
          <Button styleType="new">新規登録する</Button>
        </Link>
        <Button styleType="new" onClick={() => showUploadModal()}>
          CSVアップロード
        </Button>
      </div>

      <SubScreenTitle>学生検索</SubScreenTitle>
      <SearchForm setSearchCondition={setSearchCondition}></SearchForm>
      {unapplovalCount > 0 ? (
        <Explanation is_caution={true}>
          {"未承認が" + unapplovalCount + "件あります"}
        </Explanation>
      ) : (
        <></>
      )}
      <DataTable
        tableData={tableData}
        tableMeata={tableMeata}
        tableSortData={tableSortData}
        tableResetRef={tableResetRef}
      ></DataTable>
      <CSVDownloader
        data={csvData}
        filenameprefix="学生一覧"
        buttonname="ダウンロード"
      />
      <div className={styles.buttonbox}>
        <Link className={styles.link} to="/admin/top">
          トップページへ戻る
        </Link>
      </div>
      <StudentUploadModal
        showFlag={showUploadModalFlag}
        setShowModal={setShowUploadModalFlag}
        setReloadFlag={setReloadFlag}
        key={showUploadModalFlag}
      />
    </div>
  );
};
export default StudentUser;
